function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function ($) {
  // vars
  var apiLoaded = "object" === (typeof google === "undefined" ? "undefined" : _typeof(google)) && "object" === _typeof(google.maps);

  var acfMaps = document.querySelectorAll(".acf-map");
  var googleMaps = [];
  var customMapStyles = [{
    featureType: "water",
    elementType: "geometry",
    stylers: [{
      color: "#e9e9e9"
    }, {
      lightness: 17
    }]
  }, {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [{
      color: "#f5f5f5"
    }, {
      lightness: 20
    }]
  }, {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [{
      color: "#ffffff"
    }, {
      lightness: 17
    }]
  }, {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{
      color: "#ffffff"
    }, {
      lightness: 29
    }, {
      weight: 0.2
    }]
  }, {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{
      color: "#ffffff"
    }, {
      lightness: 18
    }]
  }, {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [{
      color: "#ffffff"
    }, {
      lightness: 16
    }]
  }, {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{
      color: "#f5f5f5"
    }, {
      lightness: 21
    }]
  }, {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{
      color: "#dedede"
    }, {
      lightness: 21
    }]
  }, {
    elementType: "labels.text.stroke",
    stylers: [{
      visibility: "on"
    }, {
      color: "#ffffff"
    }, {
      lightness: 16
    }]
  }, {
    elementType: "labels.text.fill",
    stylers: [{
      saturation: 36
    }, {
      color: "#333333"
    }, {
      lightness: 40
    }]
  }, {
    elementType: "labels.icon",
    stylers: [{
      visibility: "off"
    }]
  }, {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{
      color: "#f2f2f2"
    }, {
      lightness: 19
    }]
  }, {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [{
      color: "#fefefe"
    }, {
      lightness: 20
    }]
  }, {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [{
      color: "#fefefe"
    }, {
      lightness: 17
    }, {
      weight: 1.2
    }]
  }]; // Create info window outside of each - then tell that singular infowindow to swap content based on click

  if ($(".location-finder").length > 0) {
    var infowindow = new google.maps.InfoWindow({
      content: ""
    });
  } // Renders a Google Map onto the selected jQuery element


  function new_map($el) {
    // all map markers
    var $markers = $el.find(".marker"); // map args

    var args = {
      zoom: 25,
      center: new google.maps.LatLng(0, 0),
      mapId: "d8986ea0f0605d78"
    }; // Custom map styles used if .acf-map has .custom-styles class

    var useCustomStyles = $el.hasClass("custom-styles"); // create map

    var map = new google.maps.Map($el[0], args); // add a markers reference

    map.markers = []; // map options

    map.setOptions({
      styles: useCustomStyles ? customMapStyles : null,
      scrollwheel: false
    }); // add markers to map

    for (var i = 0; i < $markers.length; i++) {
      add_marker($($markers[i]), map, useCustomStyles);
    }

    var markerCluster = new markerClusterer.MarkerClusterer({
      markers: map.markers,
      map: map,
      imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
      maxZoom: 25,
      // Adjust the maximum zoom level for clustering
      gridSize: 50 // Adjust the grid size for clustering

    }); // center map on page load

    center_map(map); // return

    return map;
  } // Adds a marker to the selected Google Map


  function add_marker($marker, map) {
    var useCustomMarker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    //debugger;
    // marker lat/lng
    var lat = $marker.attr("data-lat");
    var lng = $marker.attr("data-lng");
    var latlng = new google.maps.LatLng(lat, lng); // let markerElement = document.createElement("div");
    // markerElement.innerHTML = $marker.html();
    // var markerElement =
    //   '<img src="/wp-content/themes/xcopper/assets/img/fake-marker.png">'; // Example HTML content for the marker
    // marker args

    var args = {
      position: {
        latlng: latlng
      },
      map: map,
      icon: "/wp-content/themes/xcopper/assets/img/marker.png"
    };
    var markerimg = document.createElement("img");
    markerimg.src = "/wp-content/themes/xcopper/assets/img/marker.png"; // create marker

    var marker = new google.maps.marker.AdvancedMarkerElement({
      position: latlng,
      map: map,
      content: markerimg
    }); // add to array

    map.markers.push(marker); // if marker contains HTML, add it to an infoWindow

    if ($marker.html()) {
      // show info window when marker is clicked & close other markers
      google.maps.event.addListener(marker, "click", function () {
        //swap content of that singular infowindow
        infowindow.setContent($marker.html());
        infowindow.open(map, marker);
      }); // close info window when map is clicked

      google.maps.event.addListener(map, "click", function (event) {
        if (infowindow) {
          infowindow.close();
        }
      });
    }
  } // Centers the map, showing all markers attached to this map


  function center_map(map) {
    var bounds = new google.maps.LatLngBounds();
    $.each(map.markers, function (i, marker) {
      bounds.extend(marker.position);
    });

    if (map.markers.length == 0) {
      // No markers, set default center and zoom
      map.setCenter({
        lat: 0,
        lng: 0
      });
      map.setZoom(2); // Example zoom level
    } else if (map.markers.length == 1) {
      // One marker, set center and zoom to that marker
      map.setCenter(bounds.getCenter());
      map.setZoom(20); // Example zoom level
    } else {
      // Multiple markers, fit to bounds
      map.fitBounds(bounds);
    } // let bounds = new google.maps.LatLngBounds();
    // let mapMarkers = map.markers;
    // // loop through all markers and create bounds
    // for (let i = 0; i < mapMarkers.length; i++) {
    //   let mapMarker = mapMarkers[i];
    //   let lat = mapMarker.position.lat();
    //   let lng = mapMarker.position.lng();
    //   let latlng = new google.maps.LatLng(lat, lng);
    //   bounds.extend(latlng);
    // }
    // // determine map position based on marker count
    // if (mapMarkers.length == 1) {
    //   // set center of map
    //   map.setCenter(bounds.getCenter());
    //   map.setZoom(16);
    // } else {
    //   // fit to bounds
    //   map.fitBounds(bounds);
    // }

  } // Wait until page loaded to create maps/center markers


  $(function () {
    var map;

    if (apiLoaded) {
      // // Render all maps
      $(".acf-map").each(function () {
        map = new_map($(this));
      });
    }

    if ($(".js-location").length > 0) {
      var initialize = function initialize() {
        var $input = document.getElementById("location-input"),
            $autocomplete = new google.maps.places.Autocomplete($input);
        $autocomplete.addListener("place_changed", function () {
          $(".js-search").trigger("click");
        }); // GeoLocator

        $(".current-loc").click(function (e) {
          e.preventDefault();
          getLocation();
        });

        function getLocation() {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (location) {
              $(".js-container").empty();
              $(".js-location").val("Current Location");
              var $lat = location.coords.latitude;
              var $lng = location.coords.longitude;
              $.ajax({
                type: "GET",
                url: api.url + "15",
                data: {
                  lat: $lat,
                  lng: $lng
                },
                success: function success(response) {
                  if (response.data.length != 0) {
                    for (var i = 0; i < map.markers.length; i++) {
                      map.markers[i].setMap(null);
                    }

                    map.markers = [];
                    $.each(response.data, function (i, item) {
                      $("<div/>").addClass("border").html('<div class="container"><div class="left"><h5>' + item["name"] + "</h5><address>" + item["address"] + '</address></div><div class="right"><a href="' + item["link"] + '">Location Details</a></div></div>').appendTo($(".js-container")); // create marker

                      var markerimg = document.createElement("img");
                      markerimg.src = "/wp-content/themes/xcopper/assets/img/marker.png";
                      var marker = new google.maps.marker.AdvancedMarkerElement({
                        position: new google.maps.LatLng(item["lat"], item["lng"]),
                        map: map,
                        title: item["name"],
                        content: markerimg
                      }); // show info window when marker is clicked & close other markers

                      google.maps.event.addListener(marker, "click", function () {
                        //swap content of that singular infowindow
                        infowindow.setContent('<h6 class="marker__heading">' + item["name"] + "</h6><a href=" + item["link"] + '" class="marker__link">Location Details</a>');
                        infowindow.open(map, marker);
                      }); // close info window when map is clicked

                      google.maps.event.addListener(map, "click", function (event) {
                        if (infowindow) {
                          infowindow.close();
                        }
                      });
                      map.markers.push(marker);
                    });
                    center_map(map);
                  } else if (response.endloop != 1) {
                    this.url = api.url + response.radius * 2;
                    this.data = {
                      lat: $lat,
                      lng: $lng
                    };
                    $.ajax(this);
                  }

                  if (response.data.length == 0 && response.endloop == 1) {
                    for (var i = 0; i < map.markers.length; i++) {
                      map.markers[i].setMap(null);
                    }

                    map.markers = []; // var marker = new google.maps.Marker({
                    //   position: new google.maps.LatLng(
                    //     $place.geometry["location"].lat(),
                    //     $place.geometry["location"].lng()
                    //   ),
                    //   map: map,
                    //   icon: "/wp-content/themes/xcopper/assets/img/fake-marker.png",
                    // });
                    // let markerElement = document.createElement("div");
                    // markerElement.innerHTML = $marker.html();

                    var markerimg = document.createElement("img");
                    markerimg.src = "/wp-content/themes/xcopper/assets/img/marker.png"; // Example HTML content for the marker
                    // create marker

                    var marker = new google.maps.marker.AdvancedMarkerElement({
                      position: new google.maps.LatLng($place.geometry["location"].lat(), $place.geometry["location"].lng()),
                      map: map,
                      content: markerimg
                    });
                    map.markers.push(marker);
                    center_map(map);
                    $("<div/>") // .addClass("no-results")
                    // .html(
                    //     "<p>It looks like we don't have any physical locations near you but we can still service all of Ontario & Alberta. The good news is we can still fight for you! You may submit your ticket online <a href=\"" +
                    //         api.quote +
                    //         '">here</a> and we\'ll get in touch with you. Or, you can call us right away at <a class="strong" href="tel:18889267737">1-888-926-7737</a></p>'
                    // )
                    .addClass("border no-links").html('<div class="container"><div class="left"><h5>' + $place.formatted_address + '</h5><span>Toll Free: <a href="tel:18889267737">1-888-926-7737</a></span><span>Text: <a href="' + $(".js-new").attr("href") + '">' + $(".js-new").html() + "</a></span></div></div>").appendTo($(".js-container"));
                  }
                }
              });
            });
          }
        }

        function onSuccess(location) {
          return location;
        }

        function onFail(error) {
          console.log(error);
        }

        $(".js-search").on("click", function (e) {
          var $place = $autocomplete.getPlace(),
              $lat = $place.geometry["location"].lat(),
              $lng = $place.geometry["location"].lng();
          $(".js-container").empty();
          $.ajax({
            type: "GET",
            url: api.url + "15",
            data: {
              lat: $lat,
              lng: $lng
            },
            success: function success(response) {
              if (response.data.length != 0) {
                for (var i = 0; i < map.markers.length; i++) {
                  map.markers[i].setMap(null);
                }

                map.markers = [];
                $.each(response.data, function (i, item) {
                  $("<div/>").addClass("border").html('<div class="container"><div class="left"><h5>' + item["name"] + "</h5><address>" + item["address"] + '</address></div><div class="right"><a href="' + item["link"] + '">Location Details</a></div></div>').appendTo($(".js-container")); // var marker = new google.maps.Marker({
                  //   position: new google.maps.LatLng(item["lat"], item["lng"]),
                  //   map: map,
                  //   icon: "/wp-content/themes/xcopper/assets/img/marker.png",
                  //   title: item["name"],
                  // });

                  var markerimg = document.createElement("img");
                  markerimg.src = "/wp-content/themes/xcopper/assets/img/marker.png";
                  var marker = new google.maps.marker.AdvancedMarkerElement({
                    position: new google.maps.LatLng(item["lat"], item["lng"]),
                    map: map,
                    title: item["name"],
                    content: markerimg
                  }); // show info window when marker is clicked & close other markers

                  google.maps.event.addListener(marker, "click", function () {
                    //swap content of that singular infowindow
                    infowindow.setContent('<h6 class="marker__heading">' + item["name"] + "</h6><a href=" + item["link"] + '" class="marker__link">Location Details</a>');
                    infowindow.open(map, marker);
                  }); // close info window when map is clicked

                  google.maps.event.addListener(map, "click", function (event) {
                    if (infowindow) {
                      infowindow.close();
                    }
                  });
                  map.markers.push(marker);
                });
                center_map(map);
              } else if (response.endloop != 1) {
                this.url = api.url + response.radius * 2;
                this.data = {
                  lat: $lat,
                  lng: $lng
                };
                $.ajax(this);
              }

              if (response.data.length == 0 && response.endloop == 1) {
                for (var i = 0; i < map.markers.length; i++) {
                  map.markers[i].setMap(null);
                }

                map.markers = []; // let markerElement = document.createElement("div");
                // markerElement.innerHTML = $marker.html();
                // create marker

                var markerimg = document.createElement("img");
                markerimg.src = "/wp-content/themes/xcopper/assets/img/marker.png";
                var marker = new google.maps.marker.AdvancedMarkerElement({
                  position: new google.maps.LatLng($place.geometry["location"].lat(), $place.geometry["location"].lng()),
                  map: map,
                  content: markerimg
                });
                map.markers.push(marker);
                center_map(map);
                $("<div/>") // .addClass("no-results")
                // .html(
                //     "<p>It looks like we don't have any physical locations near you but we can still service all of Ontario & Alberta. The good news is we can still fight for you! You may submit your ticket online <a href=\"" +
                //         api.quote +
                //         '">here</a> and we\'ll get in touch with you. Or, you can call us right away at <a class="strong" href="tel:18889267737">1-888-926-7737</a></p>'
                // )
                .addClass("border no-links").html('<div class="container"><div class="left"><h5>' + $place.formatted_address + '</h5><span>Toll Free: <a href="tel:18889267737">1-888-926-7737</a></span><span>Text: <a href="' + $(".js-new").attr("href") + '">' + $(".js-new").html() + "</a></span></div></div>").appendTo($(".js-container"));
              }
            }
          });
        });
      };

      google.maps.event.addDomListener(window, "load", initialize);
    }
  });
})(jQuery);